module.exports = __webpack_public_path__ + "static/media/flecha_abajo.b7c16e13.svg";